export default {
  namespaced: true,
  state: {
    isShowedSidebar: true,
    baseUrl: process.env.BASE_URL,
  },

  mutations: {
    setIsShowedSidebar(state, payload) {
      state.isShowedSidebar = payload;
    },
  },
  getters: {
    getIsShowedSidebar(state) {
      return state.isShowedSidebar;
    },
    getBaseUrl(state) {
      return state.baseUrl;
    },
  },
  actions: {
    /**
     * [getFile description]
     * @return {[type]} [description]
     */
    getFile(_context, url) {
      return this._vm.$http.post('/file', { url }, { responseType: 'blob' }).then((response) => {
        // console.log(response)
        return response.blob();
      });
    },

    toggleSidebar({ state, commit }) {
      commit('setIsShowedSidebar', !state.isShowedSidebar);
    },
  },
};
